import { Flag } from "@medbillai/utils/flag";

import { useStringVariation } from "../../../lib/flag";
import type { FakeDoorMmfaVariant } from "./types";

const MMFA_VARIANTS: Record<string, FakeDoorMmfaVariant> = {
  connect_existing: "connect_existing",
  create_email: "create_email",
};

export const useFakeDoorMmfaVariant = (): FakeDoorMmfaVariant | null => {
  const mmfaFlag = useStringVariation(Flag.FAKE_DOOR_MMFA, "control");
  return MMFA_VARIANTS[mmfaFlag] ?? null;
};
